import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultLedgerData, getLedgerById, addLedgerTransaction } from '@/api/ledgers';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getDealerById, searchDealers } from '@/api/dealers';
import { getQuery } from '@/utils';
import { searchDispatchedProducts } from '@/api/products';
import { searchEntryNumber } from '@/api/orders-dispatches';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultLedgerData);
    this.loading = false;
    this.dealerListLoading = false;
    this.dealerList = [];
    this.amountInWords = '';
    this.selectedProduct = null;
    this.productListLoading = false;
    this.entryNumberListLoading = false;
    this.products = [];
    this.entryNumbers = [];
    this.productData = undefined;
    this.nettRate = undefined;
    this.paymentTypeOptions = [{
      label: 'Credit Note',
      key: 'Credit Note'
    }, {
      label: 'Debit Note',
      key: 'Debit Note'
    }];
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultLedgerData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getLedgerById(id);
      this.formData = data;
      // mark as journal entry
      this.formData.paymentType = 'Journal Note';
      // fetch mapped dealer
      const dealer = await getDealerById(data.dealerId);
      this.dealerList = [dealer];
      // Just for test
      const title = 'Ledger';
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      this.dealerList = await searchDealers({
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name'
      });
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getProductList(ordersDispatchId) {
    try {
      this.productListLoading = true;
      this.products = await searchDispatchedProducts(getQuery({
        ordersDispatchId
      }));
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  async getEntryNumberList(query) {
    try {
      this.entryNumberListLoading = true;
      if (query && query.length > 2) {
        this.entryNumbers = await searchEntryNumber(getQuery({
          keyword: query,
          dealerId: this.formData.dealerId
        }));
      }
      this.entryNumberListLoading = false;
    } catch (err) {
      this.entryNumberListLoading = false;
      throw err;
    }
  }
  async handleEntryNumber(value) {
    if (value) {
      await this.getProductList(value);
    }
  }
  async handleProductSelection(value) {
    if (value) {
      this.formData.productsVariationId = value;
      this.productData = await searchDispatchedProducts({
        productsVariationId: value,
        ordersDispatchId: this.formData.ordersDispatchId
      });
    }
  }
  handleQuantity(value) {
    if (value) {
      if (this.productData) {
        this.formData.amount = parseFloat(value) * parseFloat(this.productData[0].nettRate);
      }
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        // delete id to create new journal entry
        delete this.formData.id;
      } else {
        // set ledger action as per payment type
        if (this.formData.paymentType === 'Credit Note') {
          this.formData.action = 'credit'; // reversed
          this.formData.status = 'Pending';
        } else if (this.formData.paymentType === 'Debit Note') {
          this.formData.action = 'debit'; // reversed
        }
      }
      this.formData.dealer = {
        id: this.formData.dealerId
      };
      if (this.formData.ordersDispatchId) {
        this.formData.ordersDispatch.id = this.formData.ordersDispatchId;
      }
      await addLedgerTransaction(this.formData);
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Ledger saved',
        type: 'success',
        duration: 2000
      });
      Object.assign(this.formData, {});
      Object.assign(this.products, {});
      this.selectedProduct = null;
      router.push('/ledgers/list');
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'AddCnDn',
  components: {}
})], default_1);
export default default_1;